import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AspectRatioGuide =
  | null
  | "2.35"
  | "1.85"
  | "16:9"
  | "9:16"
  | "4:5"
  | "3:4"
  | "4:3"
  | "1:1";

type TimeFormat = "standard" | "timecode" | "frames";

interface SettingsState {
  videoPlayerVolume: number;
  setVideoPlayerVolume: (v: number) => void;
  videoPlayerMuted: boolean;
  setVideoPlayerMuted: (m: boolean) => void;
  videoPlayerPlaybackRate: number;
  setVideoPlayerPlaybackRate: (r: number) => void;
  preferredTimeFormat: TimeFormat;
  setPreferredTimeFormat: (f: TimeFormat) => void;
  videoGuide: AspectRatioGuide;
  setVideoGuide: (g: AspectRatioGuide) => void;
  videoGuideMaskEnabled: boolean;
  setVideoGuideMaskEnabled: (e: boolean) => void;
  videoBackgroundWhite: boolean;
  setVideoBackgroundWhite: (w: boolean) => void;
  transcriptPanelOpen: boolean;
  setTranscriptPanelOpen: (o: boolean) => void;
}

export const useSettingsState = create<SettingsState>()(
  persist(
    (set) => ({
      videoPlayerVolume: 1,
      setVideoPlayerVolume: (v) => set({ videoPlayerVolume: v }),
      videoPlayerMuted: false,
      setVideoPlayerMuted: (m) => set({ videoPlayerMuted: m }),
      videoPlayerPlaybackRate: 1,
      setVideoPlayerPlaybackRate: (r) => set({ videoPlayerPlaybackRate: r }),
      preferredTimeFormat: "standard",
      setPreferredTimeFormat: (f) => set({ preferredTimeFormat: f }),
      videoGuide: null,
      setVideoGuide: (g) => set({ videoGuide: g }),
      videoGuideMaskEnabled: false,
      setVideoGuideMaskEnabled: (e) => set({ videoGuideMaskEnabled: e }),
      videoBackgroundWhite: false,
      setVideoBackgroundWhite: (w) => set({ videoBackgroundWhite: w }),
      transcriptPanelOpen: true,
      setTranscriptPanelOpen: (o) => set({ transcriptPanelOpen: o }),
    }),
    {
      name: "video-player-settings",
      // Bump when adding new top-level keys to invalidate stale persisted
      // state from before the key existed. Zustand's default merge usually
      // handles this, but versioning makes it explicit.
      version: 2,
    },
  ),
);
